:host {
  .suboption-label {
    margin: 0;
    padding: 0 var(--lgr-spacing-xxxs);
    font-family: var(--lgr-font-family-bold);
    cursor: default;
  }
}
